import { AppRemixIcon } from '@/layout/AppComponents';
import { useDispatch, useSelector } from 'react-redux';
import * as currentPageAction from '../../../../store/actions/currentPageAction';
import colors from '../../../../constants/colors';
import errorHandler from '../../../components/error/ErrorHandler';

export default function EnvironmentalAspectsAssessmentCardCheckbox({ id }) {
  const dispatch = useDispatch();
  const assessment = useSelector((s) => s?.currentPage?.assessment);
  const aspects = useSelector((s) => s?.currentPage?.aspects);
  const checkedCards = useSelector((state) => state.currentPage?.checkedCards);

  // > TOGGLE CHECKBOX
  const togleCheckbox = async () => {
    if (assessment?.closed) return;
    const tempCheckedCards = !checkedCards ? [] : [...checkedCards];
    try {
      if (tempCheckedCards.includes(id)) {
        dispatch(
          currentPageAction.change(
            'checkedCards',
            tempCheckedCards.filter((a) => a !== id),
            true,
          ),
        );

        const updatedAspects = { ...aspects };

        if (updatedAspects[id]) {
          const updatedAspect = {
            ...updatedAspects[id],
            comment: '',
            settings: {},
            evaluation: null,
            evaluationResult: null,
          };

          updatedAspects[id] = updatedAspect;
          dispatch(currentPageAction.change('aspects', updatedAspects, true));
        }
      } else {
        tempCheckedCards.push(id);
        dispatch(currentPageAction.change('checkedCards', tempCheckedCards, true));
      }
    } catch (err) {
      console.log(err);
      dispatch(errorHandler(err));
    }
  };
  // < TOGGLE CHECKBOX

  return (
    <>
      <AppRemixIcon
        className={assessment?.closed ? '' : 'pointer'}
        icon={
          checkedCards && checkedCards.includes(id) ? 'checkbox' : 'checkbox-blank'
        }
        title={checkedCards && checkedCards.includes(id) ? 'Aplica' : 'No aplica'}
        size={20}
        color={assessment?.closed ? colors.grey500 : colors.primary}
        onClick={() => togleCheckbox()}
      />
    </>
  );
}
